import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getAllGalleries } from "../../services/gallerieServices";
import { getSettings } from "../../services/settingsServices";

const Diaporama = () => {
  const [photos, setPhotos] = useState([]);
  const [carrouselExists, setCarrouselExists] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGalleryPhotos = async () => {
      try {
        const settings = await getSettings();
        const carrouselId = settings[0]?.carrousel_id;

        // Si carrousel_id est nul, vide ou égal à 0, on ne fait rien
        if (!carrouselId || carrouselId === 0) {
          setLoading(false);
          return;
        }

        setCarrouselExists(true); // Permet d'afficher si un carrousel est bien configuré
        const galleries = await getAllGalleries();
        const selectedGallery = galleries.find(
          (gallery) => gallery.id === carrouselId
        );
        if (selectedGallery && selectedGallery.photos) {
          setPhotos(
            selectedGallery.photos.filter((photo) => photo.is_active)
          );
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des photos:", error);
      }
      setLoading(false);
    };

    fetchGalleryPhotos();
  }, []);

  if (loading || !carrouselExists) return null;

  if (photos.length === 0) return null;

  return (
    <Carousel
      autoPlay
      infiniteLoop
      useKeyboardArrows
      dynamicHeight
      showThumbs={false}
      interval={5000}
    >
      {photos.map((photo) => (
        <div key={photo.id}>
          <img src={photo.photo_url} alt={photo.description} />
          {/* <p className="legend">{photo.description}</p> */}
        </div>
      ))}
    </Carousel>
  );
};

export default Diaporama;
